var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-competence-popup', {
    attrs: {
      "data-to-show": _vm.isNewCompetencePopupDisplayed,
      "limit": _vm.hasLimit ? 40 : null
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewCompetencePopup(false);
      },
      "addCompetence": function (newValue) {
        _vm.addNewCompetence(newValue, 'Autres');
      }
    }
  }), _vm._v(" "), _c('new-competence-metier-popup', {
    attrs: {
      "data-to-show": _vm.isNewCompetenceMetierPopupDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewCompetenceMetierPopup(false);
      },
      "addCompetence": function (newValue) {
        _vm.addNewCompetence(newValue.list, newValue.metier);
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15"
  }, [_vm._v("\n    Compétences\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasCompetences,
      expression: "!hasCompetences"
    }]
  }, [_c('h6', {
    staticClass: "mx-15 text-gray-600"
  }, [_vm._v("\n      Aucune compétence n'a été renseignée sur votre Neopass.\n    ")]), _vm._v(" "), _c('h6', {
    staticClass: "mx-15 text-gray-600 mt-5"
  }, [_vm._v("\n      Pour mettre en avant vos compétences, cliquer sur le bouton \"ajouter une\n      nouvelle compétence\"\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-base mt-10"
  }, [_vm._v("\n      Ajouter une nouvelle compétence :\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col lg:flex-row justify-center space-y-2 lg:space-x-2 mt-5 items-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "manuellement",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeStateNewCompetencePopup(true);
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("ou")]), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "liée à un métier",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeStateNewCompetenceMetierPopup(true);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasCompetences,
      expression: "hasCompetences"
    }]
  }, [_c('div', {
    staticClass: "relative w-max"
  }, [_c('add-button', {
    staticClass: "mb-8 mx-10",
    attrs: {
      "libelle": "Ajouter une nouvelle compétence",
      "with-dropdown": true
    },
    on: {
      "add": _vm.displayMenuNewComp
    }
  }), _vm._v(" "), _vm.isMenuNewCompDisplayed ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayMenuNewComp,
      expression: "displayMenuNewComp"
    }],
    staticClass: "absolute z-10 right-0 top-8 px-5 py-3 bg-white shadow rounded-xl text-sm"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5 text-gray-600"
  }, [_c('p', {
    staticClass: "hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.changeStateNewCompetenceMetierPopup(true);
      }
    }
  }, [_vm._v("\n            Ajouter une compétence liée à un métier\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.changeStateNewCompetencePopup(true);
      }
    }
  }, [_vm._v("\n            Ajouter une compétence manuellement\n          ")])])]) : _vm._e()], 1), _vm._v(" "), _vm._l(_vm.competences, function (list, metier) {
    return _c('div', {
      key: 'competences' + metier,
      staticClass: "p-0 odd:bg-gray-200 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "py-5 grid grid-cols-12 gap-x-4 items-center min-h-20 cursor-default hover:bg-indigo-200",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.metierToDisplay === metier
      },
      on: {
        "click": function ($event) {
          return _vm.displayMetier(metier);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-2 justify-self-center handle"
    }, [_c('icon', {
      staticClass: "text-pink-600 h-3 transform transition-all duration-200",
      class: {
        'rotate-90': _vm.metierToDisplay === metier
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 grid grid-cols-12 items-center"
    }, [_c('div', {
      staticClass: "col-span-2"
    }, [_vm.changedCompetences.includes(metier) && _vm.newer.data.competences[metier] ? _c('CVNewValue', {
      attrs: {
        "old": _vm.newer.data.competences[metier].map(function (c) {
          return c.value;
        }),
        "right": false
      },
      on: {
        "change": function (newValue) {
          _vm.replaceValues(metier);
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-10"
    }, [_c('p', {
      staticClass: "text-base"
    }, [_vm._v("\n              " + _vm._s(metier) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-4 flex space-x-3"
    }, [_c('p', {
      staticClass: "text-base italic font-light"
    }, [_vm._v("\n            " + _vm._s(list.length) + " compétences\n          ")])])]), _vm._v(" "), _c('transition-group', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.metierToDisplay === metier,
        expression: "metierToDisplay === metier"
      }],
      key: 'metier' + metier,
      staticClass: "bg-white px-10 py-5"
    }, [_vm.isErrorMaxLengthDisplayed ? _c('div', {
      staticClass: "text-pink-600 text-base text-center mb-8"
    }, [_vm._v("\n            Il n'y a pas assez de place pour afficher cette compétence.\n          ")]) : _vm._e(), _vm._v(" "), _vm.isErrorMinLengthDisplayed ? _c('div', {
      staticClass: "text-pink-600 text-base text-center mb-8"
    }, [_vm._v("\n            Afin d'avoir un rendu visuel optimal, il faut afficher entre 3 et\n            5 lignes.\n          ")]) : _vm._e(), _vm._v(" "), !list.every(function (comp) {
      return comp.value;
    }) ? _c('div', [_vm._v("\n            Veuillez compléter cette compétence via la page \"Parcours\" de votre carnet de parcours.\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: ""
    }, [_c('draggable', _vm._b({
      on: {
        "end": function ($event) {
          _vm.drag = false;
        },
        "start": function ($event) {
          _vm.drag = true;
        }
      },
      model: {
        value: _vm.form.data.competences[metier],
        callback: function ($$v) {
          _vm.$set(_vm.form.data.competences, metier, $$v);
        },
        expression: "form.data.competences[metier]"
      }
    }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
      staticClass: "grid grid-cols-1 md:grid-cols-3 gap-3",
      attrs: {
        "enter-active-class": "ease-in duration-1000",
        "enter-class": "bg-indigo-300 border-0 rounded-xl",
        "enter-to-class": "bg-none border-0 rounded-xl",
        "leave-active-class": "linear duration-1000",
        "leave-class": "h-20 opacity-100",
        "leave-to-class": "h-0 opacity-0",
        "tag": "div"
      }
    }, _vm._l(list, function (competence, kc) {
      return _c('div', {
        key: 'comp' + kc,
        staticClass: "col-span-1"
      }, [_c('tag', {
        staticClass: "cursor-pointer",
        attrs: {
          "theme-color": competence.isDisplayed ? 'indigo-2' : 'white',
          "libelle": competence.value,
          "text-size": "text-sm",
          "text-font": "font-light",
          "icon": competence.isDisplayed ? 'minus-circle' : 'plus-circle',
          "icon-color": competence.isDisplayed ? 'text-indigo-600' : 'text-gray-600',
          "icon-size": "w-4 h-4",
          "can-truncate": true,
          "scale-on-hover": true,
          "is-closeable": true
        },
        on: {
          "push": function ($event) {
            return _vm.displayCompetence(metier, kc);
          },
          "close": function ($event) {
            return _vm.removeCompetence(metier, kc);
          }
        }
      })], 1);
    }), 0)], 1)], 1)])])], 1);
  }), _vm._v(" "), _vm._l(_vm.newCompetences, function (list, metier) {
    return _c('div', {
      key: 'competences' + metier,
      staticClass: "p-0 odd:bg-gray-200 odd:bg-opacity-25"
    }, [_c('div', {
      staticClass: "py-5 grid grid-cols-12 gap-x-4 items-center h-20 cursor-default hover:bg-indigo-200",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.metierToDisplay === metier
      },
      on: {
        "click": function ($event) {
          return _vm.displayMetier(metier);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-2 justify-self-center handle opacity-25"
    }, [_c('icon', {
      staticClass: "text-pink-600 h-3 transform transition-all duration-200",
      class: {
        'rotate-90': _vm.metierToDisplay === metier
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-6"
    }, [_c('div', {
      staticClass: "grid grid-cols-12"
    }, [_c('div', {
      staticClass: "col-span-2"
    }, [_c('CVNewValue', {
      attrs: {
        "old": _vm.newCompetences[metier].map(function (c) {
          return c.value;
        }),
        "right": false,
        "is-new": true
      },
      on: {
        "addNew": function (newValue) {
          _vm.importFromNeopass(metier);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-10 opacity-25"
    }, [_c('p', {
      staticClass: "text-base"
    }, [_vm._v("\n                " + _vm._s(metier) + "\n              ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-4 flex space-x-3 opacity-25"
    }, [_c('p', {
      staticClass: "text-base italic font-light"
    }, [_vm._v("\n            " + _vm._s(list.length) + " compétences\n          ")])])]), _vm._v(" "), _c('transition-group', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.metierToDisplay === metier,
        expression: "metierToDisplay === metier"
      }],
      key: 'metier' + metier,
      staticClass: "bg-white px-10 py-5"
    }, [_vm.isErrorMaxLengthDisplayed ? _c('div', {
      staticClass: "text-pink-600 text-base text-center mb-8"
    }, [_vm._v("\n            Il n'y a pas assez de place pour afficher cette compétence.\n          ")]) : _vm._e(), _vm._v(" "), _vm.isErrorMinLengthDisplayed ? _c('div', {
      staticClass: "text-pink-600 text-base text-center mb-8"
    }, [_vm._v("\n            Afin d'avoir un rendu visuel optimal, il faut afficher entre 3 et\n            5 lignes.\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: ""
    }, [_c('draggable', _vm._b({
      on: {
        "end": function ($event) {
          _vm.drag = false;
        },
        "start": function ($event) {
          _vm.drag = true;
        }
      },
      model: {
        value: _vm.form.data.competences[metier],
        callback: function ($$v) {
          _vm.$set(_vm.form.data.competences, metier, $$v);
        },
        expression: "form.data.competences[metier]"
      }
    }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
      staticClass: "grid grid-cols-1 md:grid-cols-3 gap-3",
      attrs: {
        "enter-active-class": "ease-in duration-1000",
        "enter-class": "bg-indigo-300 border-0 rounded-xl",
        "enter-to-class": "bg-none border-0 rounded-xl",
        "leave-active-class": "linear duration-1000",
        "leave-class": "h-20 opacity-100",
        "leave-to-class": "h-0 opacity-0",
        "tag": "div"
      }
    }, _vm._l(list, function (competence, kc) {
      return _c('div', {
        key: 'comp' + kc,
        staticClass: "col-span-1"
      }, [_c('tag', {
        staticClass: "cursor-pointer",
        attrs: {
          "theme-color": competence.isDisplayed ? 'indigo-2' : 'white',
          "libelle": competence.value,
          "text-size": "text-sm",
          "text-font": "font-light",
          "icon": competence.isDisplayed ? 'minus-circle' : 'plus-circle',
          "icon-color": competence.isDisplayed ? 'text-indigo-600' : 'text-gray-600',
          "icon-size": "w-4 h-4",
          "can-truncate": true,
          "scale-on-hover": true
        },
        on: {
          "push": function ($event) {
            return _vm.displayCompetence(metier, kc);
          }
        }
      })], 1);
    }), 0)], 1)], 1)])])], 1);
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }